import React from 'react';
import { Teaser } from './components/Teaser';
export function App() {
  return <div className="min-h-screen bg-slate-950 text-slate-50 flex flex-col items-center justify-center p-6" data-id="element-0">
      <Teaser open={true} onClose={() => {}} data-id="element-1" />
    </div>;
}